import * as React from 'react';
const CustomDnbMinor = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g data-name="Layer 2">
      <path
        fill="#fdbb31"
        fillRule="evenodd"
        d="M14 7a7 7 0 1 1-7-7 7 7 0 0 1 7 7m-7 3a.5.5 0 1 1-.5.5.5.5 0 0 1 .5-.5m.5-6.5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0z"
        data-name="Layer 1"
      />
    </g>
  </svg>
);
export default CustomDnbMinor;
